import { memo, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { UserForm } from '../../../components/form/user-form/user-form';
import { useUser } from '../../../components/form/user-form/use-user';
import { validateUser } from '../../../models/validate-user';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IEditUserModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  handleEditUser: (data: any) => void;
  selectUser: any;
  selectedUser: any;
}

const EditUserModal = ({
  open,
  handleClose,
  handleEditUser,
  selectUser,
  selectedUser,
}: IEditUserModalProps) => {
  const { updateUser, user } = useUser(selectedUser);
  const { fieldErrors, hasErrors } = validateUser(user, [
    'contactNumber',
    'parentId',
    'password',
  ]);

  useEffect(() => {
    handleClose();
  }, [selectUser.loading]);

  const intl = useIntl();

  const onClickActionButton = () => {
    if (!hasErrors) {
      const adminData = {
        id: selectedUser._id,
        name: user.profile.name,
        contactNumber: null,
        email: user.email,
      };
      handleEditUser(adminData);
    }
  };

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'edit_admin',
      })}
      id="edit-admin-modal"
      open={open}
      isSingleButton
      handleClose={handleClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'continue',
      })}
      actionButtonDisabled={hasErrors}
    >
      <UserForm
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
        }}
        updateUser={updateUser}
        user={user}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(EditUserModal));
